import { useContext, useEffect } from "react"
import SiteContext from "../../contexts/SiteContext"
import useCustomHistory from "../../hooks/useCustomHistory"

export function RedirecionarWhatsapp() {
    const { estabelecimentoAtual } = useContext(SiteContext)
    const history = useCustomHistory()

    const limparNumero = numero => {
        if (!numero) return ""

        let numeroSomenteDigitos = String(numero).replace(/\D/g, "")

        if (numeroSomenteDigitos.startsWith("55")) {
            numeroSomenteDigitos = numeroSomenteDigitos.slice(2)
        }

        return numeroSomenteDigitos.length === 11 ? numeroSomenteDigitos : null
    }

    const numeroWhatsAppSalvo = estabelecimentoAtual?.numeroWhatsapp
    const numeroWhatsAppUsar = limparNumero(numeroWhatsAppSalvo)

    useEffect(() => {
        if (numeroWhatsAppUsar) {
            const url = `https://wa.me/${numeroWhatsAppUsar}`
            window.location.href = url
        } else {
            history.push("/")
        }
    }, [numeroWhatsAppUsar, history])

    return <></>
}
